<template>
  <GreyBarWithTitleAndValue
      is-with-borders
      title = "Number of Reels"
      :value = "$numberManagement.numberWithComma(itemData)"
  />
</template>

<script>

import GreyBarWithTitleAndValue from '../../../microcomponents/GreyBarWithTitleAndValue.vue';

export default {
  name: 'GrayBarReelsNumber',
  components: {
    GreyBarWithTitleAndValue,
  },

  props: {
    itemData: {
      type: [Number, String],
      default: null,
    },
  },
};
</script>
